export default "__VITE_ASSET__DOGHEJLt__"